import { Component } from './Component';
import { Header } from './Header';
import { Router } from '../router/Router';
import { StepBar } from './StepBar';

/**
 * Component for handling Expire User Session Error.
 */
export class Expire extends Component {
  /**
   * String of the dom element of the reload button.
   *
   * @type {string}
   */
  static btnReloadDOMSelector = '#btnExpire';

  /**
   * String of the dom element of description ( Expire Page ).
   *
   * @type {string}
   */
  static euiDescriptionExpire = '#eui-expire-one';

  /**
   * Render template.
   *
   * @param {object} opts - The options to render in the component.
   */
  render(opts) {
    Component.updateTracking({ type_page: 'expiration' });

    super.render(opts);
    Header.deleteBackButton();

    StepBar.deleteStepBar();

    this.attachSubmitEvent();
    document.querySelector(Expire.euiDescriptionExpire).focus();
  }

  /**
   * Back event treatment for Expire.
   */
  back() {
    Router.reload();
  }

  /**
   * Attach submit event.
   */
  attachSubmitEvent() {
    document.querySelector(Expire.btnReloadDOMSelector).addEventListener('click', () => {
      Router.closeApp({
        reload: true,
      });
    });
  }
}
